











































































import { Vue, Component } from 'vue-property-decorator';
import PagingUnit from '@/components/paging/paging.vue'; // 导入分页组件
import { TableStripe } from '@/mixins/tableStripe';
import CollapseTransition from '@/components/collapseTransition/collapseTransition';
import AddDialog from '@/views/trainManagement/trainRecord/addDialog.vue';
import { trainServer, dictServe, institutionServer } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';

@Component({
  components: { PagingUnit, CollapseTransition, AddDialog },
  mixins: [TableStripe],
})
export default class LicenseManagement extends Vue {
  private tableLoading = false; // loading...
  private tableData: any = [];
  private typeList: any = [];
  private methodList: any = [];
  private subSpaceByAuthOptions: any = []; // 单位
  private queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };
  private total = 0;
  searchForm: any = {
    trainName: '',
    trainCategory: '',
    trainMethod: '',
    organizerId: '',
  };

  created() {
    this.getTableData();
    this.getTypeList('train_category');
    this.getTypeList('train_method');
    this.getSubSpaceByAuth();
  }
  getTypeList(name: any) {
    dictServe.getDetailsMapByName(name).then((res: any) => {
      if (res.code === '200') {
        const helpArr: any = [];
        for (const key in res.data) {
          helpArr.push({
            value: key,
            label: res.data[key],
          });
        }
        if (name === 'train_category') {
          this.typeList = helpArr;
        } else if (name === 'train_method') {
          this.methodList = helpArr;
        }
      } else {
        this.$message.warning('获取数据失败！');
      }
    });
  }
  /**
   * @desc 获取部门所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getSubSpaceByAuth() {
    institutionServer
      .getDeptAndSubDeptList({})
      .then((res: any) => {
        this.subSpaceByAuthOptions = arrayToTree(res.data);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  private onSearch() {
    (this.queryDataForm as any).pageNo = 1;
    this.getTableData();
  }

  private onReset() {
    (this.$refs.form as any).resetFields();
    (this.queryDataForm as any).pageNo = 1;
    this.getTableData();
  }

  private getListData() {
    this.getTableData();
  }

  private getTableData() {
    this.tableLoading = true;
    trainServer
      .getTrainRecordList({
        pageNo: this.queryDataForm.pageNo,
        pageSize: this.queryDataForm.pageSize,
        trainCategory: this.searchForm.trainCategory ? this.searchForm.trainCategory : null,
        trainMethod: this.searchForm.trainMethod ? this.searchForm.trainMethod : null,
        trainName: this.searchForm.trainName ? this.searchForm.trainName : null,
        organizerId: this.searchForm.organizerId ? this.searchForm.organizerId : null,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.tableLoading = false;
          this.tableData = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.warning('获取数据失败！');
        }
      });
  }

  // 点击按钮跳到相同的弹窗
  private jumpToPublicProp(type: any, data: any) {
    const passValue: any = {
      type: type,
      data: data,
    };
    if (type === 'delete') {
      this.$confirm('此操作将永久删除当前数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          trainServer.delTrainRecordData(data).then((res: any) => {
            if (res.code === '200') {
              this.$message.success('删除成功！');
              this.getTableData();
            } else {
              this.$message.warning('网络错误，请稍后再试！');
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    } else {
      (this.$refs.AddDialog as any).showDialog(passValue);
    }
  }
}
